import './images.css'

export default function Images() {
    return (
        <main className='container-images'>
            <h1>Em breve</h1>
        </main>
    )
}